import {
  MenuItemContent,
  type MenuItemContentProps,
} from '@components/Menu/MenuItemContent.tsx';
import { classNames } from '@utils/classNames.ts';

export const ButtonMenuItem = ({
  onClick,
  className,
  showLabel,
  ...menuItemProps
}: {
  className?: string;
  onClick: () => void;
} & Omit<MenuItemContentProps, 'isActive'>) => {
  return (
    <button
      onClick={onClick}
      className={classNames(
        'menuitem h-12 group flex items-center cursor-pointer bg-transparent rounded-xl gap-1',
        showLabel ? 'w-full' : '',
        className,
      )}
    >
      {MenuItemContent({
        isActive: false,
        showLabel,
        ...menuItemProps,
      })}
    </button>
  );
};
